import actionTypes from '../actionTypes';

export const assignCoregAttribute = (field, attribute) => ({
  type: actionTypes.COREG_ASSIGN_ATTRIBUTE,
  field,
  attribute,
});

export const resetCoregAttribute = () => ({
  type: actionTypes.COREG_RESET_ATTRIBUTE,
});

export const createCoregTemp = (coreg) => ({
  type: actionTypes.COREG_TEMP_CREATE_REQUEST,
  coreg,
});

export const createCoreg = (coreg) => ({
  type: actionTypes.COREG_CREATE_REQUEST,
  coreg,
});

export const updateCoreg = (coreg) => ({
  type: actionTypes.COREG_UPDATE_REQUEST,
  coreg,
});

export const createCoregFile = (coregFile) => ({
  type: actionTypes.COREG_FILE_CREATE_REQUEST,
  coregFile,
});

export const changeCart = (cart) => ({
  type: actionTypes.COREG_CHANGE_CART,
  cart,
});



// WEBPACK FOOTER //
// src/redux/actions/coreg.js